module.exports = __webpack_public_path__ + "img/food.49c7693a.png";